var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_aspect-video _flexcol _gap-3 _jc-c _ai-c _pa-3" },
    [
      _c("base-icon", {
        staticClass: "_tc--accent",
        attrs: { name: "ban", size: "2x" },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("base-button", { on: { click: _vm.openPrivacySettings } }, [
        _vm._v("\n        Manage privacy settings\n    "),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "_tac" }, [
      _c(
        "h4",
        {
          staticClass: "gfu-hd gfu-hd--h4",
          attrs: { role: "heading", "aria-level": "4" },
        },
        [
          _vm._v(
            "\n            Your privacy settings are blocking this content\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n            To view it, please allow third-party content in your privacy settings.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }